import React, { useState, memo } from 'react';

const PlaygroundIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

const ComfyUIIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
  </svg>
);

const EditIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
  </svg>
);

const TemplateIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
  </svg>
);

const InstallIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M12 4v12m0 0l-4-4m4 4l4-4" />
  </svg>
);

const DeleteIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3m-7 0h8" />
  </svg>
);

const ModifyIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

const DetailsIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

const CopyIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
  </svg>
);

const CloudOfflineIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
  </svg>
);

const ChevronRightIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
  </svg>
);

const StatusCloudIcon = ({ active, size = 'default' }) => (
  <svg className={`${size === 'large' ? 'w-7 h-7' : 'w-5 h-5'} ${active ? 'text-cyan' : 'text-white/25'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
  </svg>
);

const StatusLocalIcon = ({ active, size = 'default' }) => (
  <svg className={`${size === 'large' ? 'w-7 h-7' : 'w-5 h-5'} ${active ? 'text-green-400' : 'text-white/25'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
);

const StatusWorkflowIcon = ({ active, size = 'default' }) => (
  <svg className={`${size === 'large' ? 'w-7 h-7' : 'w-5 h-5'} ${active ? 'text-purple-400' : 'text-white/25'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
  </svg>
);

const StatusDistributedIcon = ({ active, size = 'default' }) => (
  <svg className={`${size === 'large' ? 'w-7 h-7' : 'w-5 h-5'} ${active ? 'text-orange-400' : 'text-white/25'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
  </svg>
);

const StatusTrustedIcon = ({ active, size = 'default' }) => (
  <svg className={`${size === 'large' ? 'w-7 h-7' : 'w-5 h-5'} ${active ? 'text-yellow' : 'text-white/25'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
  </svg>
);

const StatusPublicIcon = ({ active, size = 'default' }) => (
  <svg className={`${size === 'large' ? 'w-7 h-7' : 'w-5 h-5'} ${active ? 'text-blue-400' : 'text-white/25'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

const StatusMineIcon = ({ active, size = 'default' }) => (
  <svg className={`${size === 'large' ? 'w-7 h-7' : 'w-5 h-5'} ${active ? 'text-yellow' : 'text-white/25'}`} fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" />
  </svg>
);

export const CosyflowStatusBar = memo(function CosyflowStatusBar({
  item,
  isOwned = false,
  availableModels = [],
  offlineModels = [],
  localAvailableModels = [],
  isStaffAccount = false,
  isStaffOrCreatorAccount = false,
  isInstalling = false,
  hasLocalServer = false,
  size = 'default',
  onRunInPlayground,
  onRunOfflineInPlayground,
  onRunInCosyUI,
  onRunInComfyUI,
  onInstallLocally,
  onModifyCosyflow,
  onDeleteCosyflow,
  onViewDetails,
  onCreateFromDistributed,
  onCreateTemplate,
  onTogglePublic,
  onToggleDistributed,
  showActionButtons = true,
  className = '',
}) {
  const [showActions, setShowActions] = useState(false);
  const [hoveredStatus, setHoveredStatus] = useState(null);
  const [openSubmenu, setOpenSubmenu] = useState(null);

  const formatDate = (dateValue) => {
    if (!dateValue) return null;
    const date = new Date(dateValue);
    if (isNaN(date.getTime())) return null;
    return date.toLocaleDateString();
  };

  const isPublic = item.isPublic === true;
  const isDistributed = item.distributed === true;
  const isTrusted = item.trusted === true;
  const isSameUser = isOwned;

  const isAvailableOnline = availableModels.includes(item.title);
  const isAvailableOffline = offlineModels.some(m => m.value === item.title);
  const isAvailableLocally = localAvailableModels.length > 0 && localAvailableModels.includes(item.title);

  const hasWorkflow = item.hasComfyWorkflow === true;

  const canRunOnlineInPlayground = isAvailableOnline;
  const canRunOfflineInPlayground = isAvailableLocally;
  const canLoadDistributedInCosyUI = hasWorkflow;
  const canLoadMyInCosyUI = isSameUser && hasWorkflow;
  const canLoadInCosyUI = canLoadDistributedInCosyUI || canLoadMyInCosyUI;
  const canMakeMyAvailableLocally = !isDistributed && isSameUser && !isAvailableLocally && !isAvailableOffline && hasWorkflow;
  const canMakePublicAvailableLocally = isDistributed && isTrusted && !isAvailableLocally && !isAvailableOffline && hasWorkflow;
  const canMakeAvailableLocally = canMakeMyAvailableLocally || canMakePublicAvailableLocally;
  const canModifyCosyflow = isSameUser;
  const canCreateFromDistributed = isDistributed || isSameUser;
  const canCreateTemplateFromPublicOnline = isAvailableOnline;
  const canCreateTemplateFromOffline = isSameUser;
  const canCreateTemplate = canCreateTemplateFromPublicOnline || canCreateTemplateFromOffline;
  const canInstallLocally = isDistributed && isTrusted && !item.isLocal && !isAvailableOffline && !isAvailableLocally && onInstallLocally;

  const handleActionClick = (e, action) => {
    e.stopPropagation();
    const mode = 'online';
    setShowActions(false);
    action?.(item, { mode });
  };

  return (
    <div className={`relative ${className}`}>
      <div className="bg-gradient-to-br from-white/5 to-white/[0.02] border border-white/10 rounded-2xl p-4">
        <div className={`flex items-center justify-center ${size === 'large' ? 'gap-3' : 'gap-2'} flex-wrap`}>
          <div
            onClick={(e) => {
              e.stopPropagation();
              setShowActions(!showActions);
            }}
            className={`relative ${size === 'large' ? 'p-2.5' : 'p-1.5'} rounded-md bg-black/50 text-white hover:bg-black/70 transition-all cursor-pointer ${showActions ? 'ring-2 ring-white' : ''}`}
          >
            <svg className={size === 'large' ? 'w-7 h-7' : 'w-5 h-5'} fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
            </svg>
            {showActions && showActionButtons && (
              <div className="absolute top-full left-0 mt-1 z-30 min-w-[200px] bg-[#1a1f2e] rounded-xl shadow-2xl border border-white/10 overflow-visible">
                <div className="py-1">
                  {(canRunOnlineInPlayground || canRunOfflineInPlayground || canLoadInCosyUI || canInstallLocally) && (
                    <>
                      {canRunOnlineInPlayground && onRunInPlayground && (
                        <button
                          onClick={(e) => handleActionClick(e, onRunInPlayground)}
                          className="w-full flex items-center gap-3 px-4 py-2.5 text-white/90 hover:bg-white/10 transition-colors"
                        >
                          <PlaygroundIcon />
                          <span className="whitespace-nowrap">Run Online in Playground</span>
                        </button>
                      )}
                      {canRunOfflineInPlayground && (onRunOfflineInPlayground || onRunInPlayground) && (
                        <button
                          onClick={(e) => handleActionClick(e, onRunOfflineInPlayground || onRunInPlayground)}
                          className="w-full flex items-center gap-3 px-4 py-2.5 text-white/90 hover:bg-white/10 transition-colors"
                        >
                          <CloudOfflineIcon />
                          <span className="whitespace-nowrap">Run Offline in Playground</span>
                        </button>
                      )}
                      {canLoadInCosyUI && onRunInCosyUI && isStaffOrCreatorAccount && (
                        <button
                          onClick={(e) => handleActionClick(e, onRunInCosyUI)}
                          className="w-full flex items-center gap-3 px-4 py-2.5 text-white/90 hover:bg-white/10 transition-colors"
                        >
                          <ComfyUIIcon />
                          <span className="whitespace-nowrap">Load in CosyUI</span>
                        </button>
                      )}
                      {canLoadInCosyUI && onRunInComfyUI && (
                        <div className="relative group/comfyui">
                          <button
                            onClick={(e) => hasLocalServer && handleActionClick(e, onRunInComfyUI)}
                            disabled={!hasLocalServer}
                            className={`w-full flex items-center gap-3 px-4 py-2.5 transition-colors ${hasLocalServer ? 'text-white/90 hover:bg-white/10' : 'text-white/30 cursor-not-allowed'}`}
                          >
                            <ComfyUIIcon />
                            <span className="whitespace-nowrap">Load in ComfyUI</span>
                          </button>
                          {!hasLocalServer && (
                            <span className="absolute left-1/2 -translate-x-1/2 bottom-full mb-1 px-2 py-1 bg-black/90 text-white text-xs rounded whitespace-nowrap opacity-0 group-hover/comfyui:opacity-100 pointer-events-none transition-opacity z-50">
                              Start a local ComfyUI server to enable this
                            </span>
                          )}
                        </div>
                      )}
                      {canInstallLocally && onInstallLocally && (
                        <div className="relative group/install">
                          <button
                            onClick={(e) => hasLocalServer && !isInstalling && handleActionClick(e, onInstallLocally)}
                            disabled={!hasLocalServer || isInstalling}
                            className={`w-full flex items-center gap-3 px-4 py-2.5 transition-colors ${!hasLocalServer ? 'text-white/30 cursor-not-allowed' : isInstalling ? 'text-white/90 opacity-50 cursor-not-allowed' : 'text-white/90 hover:bg-white/10'}`}
                          >
                            {isInstalling ? (
                              <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                            ) : (
                              <InstallIcon />
                            )}
                            <span className="whitespace-nowrap">{isInstalling ? 'Installing...' : 'Install Locally'}</span>
                          </button>
                          {!hasLocalServer && (
                            <span className="absolute left-1/2 -translate-x-1/2 bottom-full mb-1 px-2 py-1 bg-black/90 text-white text-xs rounded whitespace-nowrap opacity-0 group-hover/install:opacity-100 pointer-events-none transition-opacity z-50">
                              Start a local ComfyUI server to enable this
                            </span>
                          )}
                        </div>
                      )}
                      <div className="border-t border-white/10 my-1" />
                    </>
                  )}

                  {canCreateFromDistributed && onCreateFromDistributed && (
                    <div
                      className="relative"
                      onMouseEnter={() => setOpenSubmenu('editor')}
                      onMouseLeave={() => setOpenSubmenu(null)}
                    >
                      <button className="w-full flex items-center justify-between px-4 py-2.5 text-white/90 hover:bg-white/10 transition-colors">
                        <div className="flex items-center gap-3">
                          <EditIcon />
                          <span>Edit</span>
                        </div>
                        <ChevronRightIcon />
                      </button>
                      {openSubmenu === 'editor' && (
                        <div className="absolute left-full top-0 -ml-2 pl-2 min-w-[180px]">
                          <div className="bg-[#1a1f2e] rounded-lg shadow-2xl border border-white/10 py-1">
                            <button
                              onClick={(e) => handleActionClick(e, onCreateFromDistributed)}
                              className="w-full flex items-center gap-3 px-4 py-2.5 text-white/90 hover:bg-white/10 transition-colors"
                            >
                              <CopyIcon />
                              <span>Cosyflow Editor</span>
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {canCreateTemplate && onCreateTemplate && (
                    <button
                      onClick={(e) => handleActionClick(e, onCreateTemplate)}
                      className="w-full flex items-center gap-3 px-4 py-2.5 text-white/90 hover:bg-white/10 transition-colors whitespace-nowrap"
                    >
                      <TemplateIcon />
                      <span>Create Template</span>
                    </button>
                  )}

                  {onViewDetails && (
                    <button
                      onClick={(e) => handleActionClick(e, onViewDetails)}
                      className="w-full flex items-center gap-3 px-4 py-2.5 text-white/90 hover:bg-white/10 transition-colors"
                    >
                      <DetailsIcon />
                      <span>Showcase</span>
                    </button>
                  )}

                  {(() => {
                    const createdFormatted = formatDate(item.created_date);
                    const updatedFormatted = formatDate(item.updated_date);
                    if (!createdFormatted && !updatedFormatted) return null;
                    return (
                      <>
                        <div className="border-t border-white/10 my-1" />
                        {createdFormatted && (
                          <div className="w-full flex items-center justify-between px-4 py-2 text-white/50 text-sm">
                            <span>Created</span>
                            <span>{createdFormatted}</span>
                          </div>
                        )}
                        {updatedFormatted && (
                          <div className="w-full flex items-center justify-between px-4 py-2 text-white/50 text-sm">
                            <span>Updated</span>
                            <span>{updatedFormatted}</span>
                          </div>
                        )}
                      </>
                    );
                  })()}

                  {(isOwned || item.isLocal) && onDeleteCosyflow && (
                    <>
                      <div className="border-t border-white/10 my-1" />
                      <button
                        onClick={(e) => handleActionClick(e, onDeleteCosyflow)}
                        className="w-full flex items-center gap-3 px-4 py-2.5 text-red-400 hover:bg-red-500/20 transition-colors"
                      >
                        <DeleteIcon />
                        <span>Delete</span>
                      </button>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
          <div className={`w-px ${size === 'large' ? 'h-10' : 'h-8'} bg-white/70`} />
          <div
            className={`relative ${size === 'large' ? 'p-2.5' : 'p-1.5'} rounded-md cursor-pointer transition-all hover:scale-110 ${isOwned ? 'bg-yellow/30' : 'bg-black/50'}`}
            onClick={(e) => e.stopPropagation()}
            onMouseEnter={() => setHoveredStatus('mine')}
            onMouseLeave={() => setHoveredStatus(null)}
          >
            <StatusMineIcon active={isOwned} size={size} />
            {hoveredStatus === 'mine' && (
              <span className="absolute left-1/2 -translate-x-1/2 top-full mt-1 px-2 py-1 bg-black text-xs rounded whitespace-nowrap z-50 shadow-lg border border-white" style={{ color: '#fff' }}>
                {isOwned ? 'My Cosyflow' : 'Not Mine'}
              </span>
            )}
          </div>
          <div
            className={`relative ${size === 'large' ? 'p-2.5' : 'p-1.5'} rounded-md cursor-pointer transition-all hover:scale-110 ${isAvailableOnline ? 'bg-cyan/30' : 'bg-black/50'}`}
            onClick={(e) => e.stopPropagation()}
            onMouseEnter={() => setHoveredStatus('online')}
            onMouseLeave={() => setHoveredStatus(null)}
          >
            <StatusCloudIcon active={isAvailableOnline} size={size} />
            {hoveredStatus === 'online' && (
              <span className="absolute left-1/2 -translate-x-1/2 top-full mt-1 px-2 py-1 bg-black text-xs rounded whitespace-nowrap z-50 shadow-lg border border-white" style={{ color: '#fff' }}>
                {isAvailableOnline ? 'Available Online' : 'Not Available Online'}
              </span>
            )}
          </div>
          <div
            className={`relative ${size === 'large' ? 'p-2.5' : 'p-1.5'} rounded-md cursor-pointer transition-all hover:scale-110 ${isAvailableLocally ? 'bg-green-400/30' : 'bg-black/50'}`}
            onClick={(e) => e.stopPropagation()}
            onMouseEnter={() => setHoveredStatus('local')}
            onMouseLeave={() => setHoveredStatus(null)}
          >
            <StatusLocalIcon active={isAvailableLocally} size={size} />
            {hoveredStatus === 'local' && (
              <span className="absolute left-1/2 -translate-x-1/2 top-full mt-1 px-2 py-1 bg-black text-xs rounded whitespace-nowrap z-50 shadow-lg border border-white" style={{ color: '#fff' }}>
                {isAvailableLocally ? 'Available Locally' : 'Not Available Locally'}
              </span>
            )}
          </div>
          <div
            className={`relative ${size === 'large' ? 'p-2.5' : 'p-1.5'} rounded-md cursor-pointer transition-all hover:scale-110 ${hasWorkflow ? 'bg-purple-400/30' : 'bg-black/50'}`}
            onClick={(e) => e.stopPropagation()}
            onMouseEnter={() => setHoveredStatus('workflow')}
            onMouseLeave={() => setHoveredStatus(null)}
          >
            <StatusWorkflowIcon active={hasWorkflow} size={size} />
            {hoveredStatus === 'workflow' && (
              <span className="absolute left-1/2 -translate-x-1/2 top-full mt-1 px-2 py-1 bg-black text-xs rounded whitespace-nowrap z-50 shadow-lg border border-white" style={{ color: '#fff' }}>
                {hasWorkflow ? 'Has Workflow' : 'No Workflow'}
              </span>
            )}
          </div>
          <div
            className={`relative ${size === 'large' ? 'p-2.5' : 'p-1.5'} rounded-md transition-all hover:scale-110 ${isDistributed ? 'bg-orange-400/30' : 'bg-black/50'} ${isOwned && onToggleDistributed ? 'cursor-pointer ring-2 ring-transparent hover:ring-orange-400/50' : 'cursor-default'}`}
            onClick={(e) => {
              e.stopPropagation();
              if (isOwned && onToggleDistributed) {
                onToggleDistributed(item, !isDistributed);
              }
            }}
            onMouseEnter={() => setHoveredStatus('distributed')}
            onMouseLeave={() => setHoveredStatus(null)}
          >
            <StatusDistributedIcon active={isDistributed} size={size} />
            {hoveredStatus === 'distributed' && (
              <span className="absolute left-1/2 -translate-x-1/2 top-full mt-1 px-2 py-1 bg-black text-xs rounded whitespace-nowrap z-50 shadow-lg border border-white" style={{ color: '#fff' }}>
                {isOwned && onToggleDistributed
                  ? (isDistributed ? 'Click to un-distribute' : 'Click to distribute')
                  : (isDistributed ? 'Distributed' : 'Not Distributed')}
              </span>
            )}
          </div>
          <div
            className={`relative ${size === 'large' ? 'p-2.5' : 'p-1.5'} rounded-md cursor-pointer transition-all hover:scale-110 ${isTrusted ? 'bg-yellow/30' : 'bg-black/50'}`}
            onClick={(e) => e.stopPropagation()}
            onMouseEnter={() => setHoveredStatus('trusted')}
            onMouseLeave={() => setHoveredStatus(null)}
          >
            <StatusTrustedIcon active={isTrusted} size={size} />
            {hoveredStatus === 'trusted' && (
              <span className="absolute left-1/2 -translate-x-1/2 top-full mt-1 px-2 py-1 bg-black text-xs rounded whitespace-nowrap z-50 shadow-lg border border-white" style={{ color: '#fff' }}>
                {isTrusted ? 'Trusted' : 'Not Trusted'}
              </span>
            )}
          </div>
          <div
            className={`relative ${size === 'large' ? 'p-2.5' : 'p-1.5'} rounded-md transition-all hover:scale-110 ${isPublic ? 'bg-blue-400/30' : 'bg-black/50'} ${isOwned && onTogglePublic ? 'cursor-pointer ring-2 ring-transparent hover:ring-blue-400/50' : 'cursor-default'}`}
            onClick={(e) => {
              e.stopPropagation();
              if (isOwned && onTogglePublic) {
                onTogglePublic(item, !isPublic);
              }
            }}
            onMouseEnter={() => setHoveredStatus('public')}
            onMouseLeave={() => setHoveredStatus(null)}
          >
            <StatusPublicIcon active={isPublic} size={size} />
            {hoveredStatus === 'public' && (
              <span className="absolute left-1/2 -translate-x-1/2 top-full mt-1 px-2 py-1 bg-black text-xs rounded whitespace-nowrap z-50 shadow-lg border border-white" style={{ color: '#fff' }}>
                {isOwned && onTogglePublic
                  ? (isPublic ? 'Click to make private' : 'Click to make public')
                  : (isPublic ? 'Public' : 'Private')}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

export default CosyflowStatusBar;
